import { useEffect, useState } from 'react';

const useSrcSetVerify = (urlBase?: string, format?: string) => {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!urlBase || !format) {
      setUrl(null);
      return;
    }

    const baseForatURL = urlBase.split('/');
    const lastURL = baseForatURL.pop();

    if (!lastURL) {
      setUrl(null);
      return;
    }

    const joinBaseForatURL = baseForatURL.join('/');
    const lastURLArray = lastURL.split('.');

    if (lastURLArray.length < 2) {
      setUrl(null);
      return;
    }

    const createURL =
      `${joinBaseForatURL}/${lastURLArray[0]}-format-${format}.${lastURLArray[1]}`;

    const img = new Image();

    img.onload = () => {
      setUrl(createURL);
    };

    img.onerror = () => {
      setUrl(null);
    };

    img.src = createURL;

    // cleanup (boa prática)
    return () => {
      img.onload = null;
      img.onerror = null;
    };
  }, [urlBase, format]);

  return url;
};

export default useSrcSetVerify;
